import { useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/store/use-auth-store';
import { useGetApplications } from '@/hooks/process';
import ApplicationsList from "@/components/applications/applications-list";

const DisabledApplicationsPage = () => {
  const { user } = useAuthStore();
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const { data: responseData, isLoading, isError } = user?.id
    ? useGetApplications('disabled', false, { page, limit: 20, search: search || undefined })
    : { data: null, isLoading: false, isError: false };

  if (!user?.id) {
    return (
      <div className="text-center py-8 text-gray-700">
        {t('processManagement.loading')}
      </div>
    );
  }

  const data = responseData?.data || [];
  const meta = responseData?.meta;

  const handleSearchChange = useCallback((s: string) => {
    setSearch(s);
    setPage(1);
  }, []);

  return (
    <ApplicationsList
      data={data}
      isLoading={isLoading}
      isError={isError}
      title={t('processManagement.disabledApplications')}
      loadingMessage={t('processManagement.loading')}
      errorMessage={t('processManagement.anErrorOccurredWhileFetchingDisabledApplications')}
      searchPlaceholder={t('processManagement.search')}
      baseRoute="/staff/incoming/disabled-applications"
      noDataMessage={t('processManagement.noDisabledApplicationsFound')}
      meta={meta}
      search={search}
      onSearchChange={handleSearchChange}
      onPageChange={setPage}
    />
  );
};

export default DisabledApplicationsPage;